export default "__VITE_ASSET__DqtPlz0u__"